export enum GetNumberOfUnitType {
  API = 'API',
  MANUAL = 'MANUAL',
}

export enum Softwares {
  NONE = 'None',
  ENTRATA = 'Entrata',
  YARDI = 'Yardi',
  RENT_MANAGER = 'Rent Manager',
  APPFOLIO = 'Appfolio',
  REAL_PAGE = 'RealPage',
  RESMAN = 'ResMan',
  MRI = 'MRI',
  OTHER = 'Other',
}

export enum DaysOfWeek {
  monday,
  tuesday,
  wednesday,
  thursday,
  friday,
  saturday,
  sunday,
}

export enum CompaniesSortBy {
  COMPANY = 'company',
  NUMBER_OF_UNITS = 'numberOfUnits',
  ORGANIZATION = 'organization',
  TWILIO_NUMBER = 'twilioNumber',
  CREATED_AT = 'createdAt',
  USERS = 'users',
  SUBSCRIPTION = 'subscription',
}

export enum SettlementAmountHandleMethod {
  MANUAL = 'Manual',
  AUTOMATIC = 'Automatic',
}

export enum DebtCollectionPaymentLinkHandleMethod {
  COMPANY = 'company',
  STRIPE = 'stripe',
}

export enum ReminderMessagesCommunicationMethods {
  EMAIL = 'email',
  SMS = 'sms',
  CALL = 'call',
}

export enum ReminderMessagesMethods {
  GEN_AI = 'gen AI',
  SCHEDULER = 'scheduler',
  GRAPH = 'graph',
}

export enum PropertyManagementFeaturesKeyNames {
  RENT_COLLECTION = 'rentCollection',
  DEBT_COLLECTION = 'debtCollection',
  RENEWALS = 'renewals',
  LEASING = 'leasing',
  LEASE_RENEWALS = 'leaseRenewals',
  MAINTENANCE = 'maintenance',
}

export enum CompanyTabs {
  LEFT_MENU_SETTINGS = 'Left Menu Settings',
  API_CREDENTIALS = 'API Credentials',
  RENT_COLLECTION = 'Rent Collection',
  RENEWALS = 'Renewals',
  LEASING = 'Leasing',
  DEBT_COLLECTION = 'Debt Collection',
  REPORTS = 'Reports',
  AI_MODULES = 'AI Modules',
  WORKING_HOURS = 'Working Hours',
  MAINTENANCE = 'Maintenance',
}

export enum RenewalsMethod {
  MANUAL = 'manual',
  LRO_STATUS = 'LRO status',
}

export enum RenewalTenantType {
  CONVENTIONAL = 'Conventional',
  STUDENT = 'Student',
}

export enum StudentTimingOption {
  IMMEDIATELY = 'Immediately when a renewal offer has been generated',
  SPECIFIC_DATE = 'A specific date',
  DAYS_TO_EXPIRATION = 'Days to offer expiration',
}

export enum CustomersUserTypes {
  ORGANIZATION_MANAGER = 'Organization Manager',
  MANAGER = 'Manager',
  USER = 'User',
  PROPERTY_MANAGER = 'Property Manager',
  ASSISTANT_PROPERTY_MANAGER = 'Assistant Property Manager',
  LEASING_AGENT = 'Leasing Agent',
}
